import z from 'zod';
import parsePhoneNumberFromString from 'libphonenumber-js';
import { ContactNumberType } from '../types/tenancies';

const zPhone = z.string().transform((arg, ctx) => {
    if (arg === '') {
        return arg;
    }

    const phoneNumber = parsePhoneNumberFromString(arg, {
        defaultCountry: 'AU',
        extract: false,
    });

    if (phoneNumber && phoneNumber.isValid()) {
        return phoneNumber.number;
    }

    ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Please enter a valid contact number',
    });

    return z.NEVER as string;
});

const zContactNumber = z.object({
    contactNumberId: z.number()
        .int()
        .positive()
        .optional(),
    number: zPhone.pipe(z.string().min(1, 'Contact number is required')),
    type: z.nativeEnum(ContactNumberType).nullable(),
});

export { zPhone, zContactNumber };
